import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/admin/dashboard/page.jsx");
